import { render, staticRenderFns } from "./EditInformasiUmum.vue?vue&type=template&id=54174f9e&scoped=true&"
import script from "./EditInformasiUmum.vue?vue&type=script&lang=js&"
export * from "./EditInformasiUmum.vue?vue&type=script&lang=js&"
import style0 from "./EditInformasiUmum.vue?vue&type=style&index=0&id=54174f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54174f9e",
  null
  
)

export default component.exports